// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bXTfC .P8Yuw{font-size:1.7rem}.bXTfC .Ihfqc{display:flex;flex-direction:column;gap:.15rem;min-width:0}.bXTfC .Ud9bZ{align-self:flex-start;font-weight:700;max-width:100%}.bXTfC .a76LT{color:var(--anchore-color-gray-600);font-size:.85rem;min-width:0}.bXTfC .OIjBk{color:var(--anchore-color-gray-500)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `bXTfC`,
	"fixIcon": `P8Yuw`,
	"versionCell": `Ihfqc`,
	"versionName": `Ud9bZ`,
	"description": `a76LT`,
	"placeholder": `OIjBk`
};
module.exports = ___CSS_LOADER_EXPORT___;
